import {IsActiveMatchOptions} from '@angular/router';

export interface CoreNavigationItem {
    id?: string;
    title?: string;
    subtitle?: string;
    type:
        | 'aside'
        | 'basic'
        | 'collapsable'
        | 'divider'
        | 'group'
        | 'spacer';
    hidden?: (item: CoreNavigationItem) => boolean;
    active?: boolean;
    disabled?: boolean;
    tooltip?: string;
    link?: string;
    externalLink?: boolean;
    unitInstance?: number;
    target?:
        | '_blank'
        | '_self'
        | '_parent'
        | '_top'
        | string;
    exactMatch?: boolean;
    isActiveMatchOptions?: IsActiveMatchOptions;
    function?: (item: CoreNavigationItem) => void;
    classes?: {
        title?: string;
        subtitle?: string;
        icon?: string;
        wrapper?: string;
    };
    icon?: string;
    badge?: {
        title?: string;
        classes?: string;
    };
    children?: CoreNavigationItem[];
    meta?: any;
}

export type CoreVerticalNavigationAppearance =
    | 'default';

export type CoreVerticalNavigationMode =
    | 'over'
    | 'side';

export type CoreVerticalNavigationPosition =
    | 'left'
    | 'right';
